<script setup lang="ts">
import type { ChatMessage } from '../../../types/chat'

import { computed } from 'vue'

import MarkdownRenderer from '../../markdown/MarkdownRenderer.vue'

const props = withDefaults(defineProps<{
  message: Extract<ChatMessage, { role: 'user' }>
  label: string
  variant?: 'desktop' | 'mobile'
}>(), {
  variant: 'desktop',
})

const content = computed(() => {
  const raw = props.message.content
  if (typeof raw === 'string')
    return raw

  if (Array.isArray(raw)) {
    const textPart = raw.find(part => 'type' in part && part.type === 'text') as { text?: string } | undefined
    if (textPart?.text)
      return textPart.text

    return raw.map(entry => JSON.stringify(entry)).join('\n')
  }

  return ''
})

const containerClasses = computed(() => [
  'flex',
  props.variant === 'mobile' ? 'ml-0 flex-row' : 'ml-12 flex-row-reverse',
])

const boxClasses = computed(() => [
  props.variant === 'mobile' ? 'px-2 py-2 text-sm' : 'px-3 py-3',
])
</script>

<template>
  <div v-if="message.role === 'user'" :class="containerClasses" class="ph-no-capture">
    <div
      flex="~ col"
      min-w-20 rounded-xl h="unset <sm:fit"
      class="comic-bubble comic-bubble-user"
      :class="boxClasses"
    >
      <div>
        <span text-xs text="black/70" font-normal font-who-dares class="inline <sm:hidden">{{ label }}</span>
      </div>
      <MarkdownRenderer
        :content="content as string"
        class="break-words font-who-dares text-black"
      />
    </div>
  </div>
</template>

<style scoped>
.comic-bubble {
  background: white;
  border: 2px solid black;
}

.comic-bubble-user {
  box-shadow: 3px 3px 0 0 rgba(0, 0, 0, 0.7);
}
</style>
